import {
  Dialog,
  Table,
  TableBody,
  TableRow,
  TableRowColumn,
} from "material-ui";
import React from "react";
import { FormattedMessage } from "react-intl";
import images from "../../config/images";
import DialogTitle from "../Shared/DialogTitle";
import { tdStyle } from "./QuestionnaireTable";

class TemplateTableDialog extends React.Component {
  render() {
    return (
      <Dialog
        modal={false}
        title={
          <DialogTitle
            heading={<FormattedMessage id="questionnaire.template" />}
            handleClose={this.props.handleClose}
          />
        }
        open={this.props.open}
        onRequestClose={this.props.handleClose}
        contentClassName="popup-modal-content"
        contentStyle={{ maxWidth: "970px", width: "96%" }}
        bodyStyle={{ padding: 0 }}
        autoScrollBodyContent={true}
        className="popup-modal"
        bodyClassName="popup-modal-body table-padding"
      >
        <div
          style={{
            backgroundColor: "rgb(241, 241, 241)",
            padding: "20px 30px",
            overflowX: "hidden",
            overflowY: "auto",
          }}
        >
          <Table
            selectable={false}
            selectedColor="black"
            // height={"70vh"}
            bodyStyle={{
              display: "contents",
            }}
            style={{
              border: "1px solid #b8b8b8",
              marginTop: "8px",
              minWidth: "612px",
            }}
          >
            <TableBody deselectOnClickaway={false} displayRowCheckbox={false}>
              <TableRow
                style={{
                  border: "1px solid #b8b8b8",
                  backgroundColor: "#6B7c93",
                  color: "#fff",
                }}
              >
                <TableRowColumn
                  colSpan={2}
                  style={{ ...tdStyle, color: "#fff" }}
                >
                  {<FormattedMessage id="questionnaire.title" />}
                </TableRowColumn>

                <TableRowColumn
                  colSpan={4}
                  style={{ ...tdStyle, color: "#fff" }}
                >
                  {<FormattedMessage id="questionnaire.question" />}
                </TableRowColumn>

                <TableRowColumn
                  colSpan={1}
                  style={{ ...tdStyle, color: "#fff" }}
                >
                  {<FormattedMessage id="emailAddressBook.edit" />}
                </TableRowColumn>

                <TableRowColumn
                  colSpan={1}
                  style={{ ...tdStyle, color: "#fff" }}
                >
                  {<FormattedMessage id="seminarActions.tableOptions.add" />}
                </TableRowColumn>
              </TableRow>

              {this.props.isFetchingTemplates ||
                (this.props.templates.length === 0 && (
                  <TableRow
                    selected={false}
                    className="light-row"
                    style={{
                      backgroundColor: "#f2f3f6",
                      borderBottom: "1px solid #b8b8b8",
                    }}
                  >
                    <TableRowColumn colSpan={8} style={tdStyle}>
                      {this.props.isFetchingTemplates
                        ? <FormattedMessage id="questionnaire.fetchingTemplates" />
                        : <FormattedMessage id="questionnaire.noTemplates" />}
                    </TableRowColumn>
                  </TableRow>
                ))}

              {this.props.templates.map((template, index) => {
                return (
                  <TableRow
                    key={index}
                    selected={false}
                    className={index % 2 == 0 ? "dark-row" : "light-row"}
                    style={{
                      backgroundColor: "#f2f3f6",
                      borderBottom: "1px solid #b8b8b8",
                    }}
                  >
                    <TableRowColumn colSpan={2} style={tdStyle}>
                      {template.title}
                    </TableRowColumn>
                    <TableRowColumn colSpan={4} style={tdStyle}>
                      {template.question}
                    </TableRowColumn>
                    <TableRowColumn style={tdStyle}>
                      <img
                        src={images.pencilOutline}
                        style={{ width: "24px", cursor: "pointer" }}
                        onClick={() => {
                          this.props.editTemplate(template);
                        }}
                      />
                    </TableRowColumn>
                    <TableRowColumn style={tdStyle}>
                      <img
                        src={images.addOutline}
                        style={{ width: "24px", cursor: "pointer" }}
                        onClick={() => {
                          this.props.addTemplateToQuestionnaire(template);
                        }}
                      />
                    </TableRowColumn>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </div>
      </Dialog>
    );
  }
}

export default TemplateTableDialog;



// WEBPACK FOOTER //
// src/components/Questionnaire/TemplateTableDialog.js